import * as React from "react";

const OpenEye = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#161616"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8"
    ></path>
    <path
      stroke="#161616"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    ></path>
  </svg>
);

export default OpenEye;
